"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshNotificationsWithIntervalHandler = exports.refreshNotificationsHandler = exports.getFlightNotificationCountHandler = exports.getFlightOfferTotalPriceHandler = exports.getFlightTotalPriceHandler = exports.startFlightOfferPaymentHandler = exports.startFlightPaymentHandler = exports.changeDedicatedStatusHandler = exports.declineFlightOfferHandler = exports.getFlightOfferHandler = exports.offerFlightHandler = exports.ratePilotHandler = exports.ratePassengersHandler = exports.cancelFlightHandler = exports.getMyFlightDetailsHandler = exports.getFlightDetailsHandler = exports.getMyOffersHandler = exports.getMyFlightsHandler = exports.SearchFlightsHandler = exports.getNearbyFlightsHandler = exports.publishFlightHandler = void 0;
const flights_1 = require("../http/flights");
const store_1 = require("../store/redux/store");
const flight_1 = require("../store/redux/flight");
const utils_1 = require("../services/utils");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const messageHandlers_1 = require("./messageHandlers");
const publishFlightHandler = async (data, asAPilot, navigate) => {
    const requestData = {
        ...(0, lodash_1.omit)(data, ['departureAirport', 'destinationAirport', "date", 'aircraft']),
        departure_from_id: data.departureAirport ? data.departureAirport.id : null,
        destination_to_id: data.destinationAirport ? data.destinationAirport.id : null,
        departure_datetime: data.date,
        aircraft_id: data.aircraft && (0, lodash_1.isNumber)(data.aircraft.id) ? data.aircraft.id : undefined,
        request: !asAPilot,
        dedicated: asAPilot ? data.dedicated : true,
        available_seats: data.seats,
        stopovers: data.stopovers,
        flight_time: data.duration
    };
    await (0, flights_1.publishFlight)(requestData).then(response => {
        if (response.status === 200) {
            const flightDetails = (0, utils_1.prepareFlightDetailsData)(response.data);
            store_1.store.dispatch((0, flight_1.setFlightDetails)(flightDetails));
            navigate();
            store_1.store.dispatch((0, flight_1.resetPublishStateAction)());
        }
    }).catch(error => {
        console.log(error);
        throw error;
    });
};
exports.publishFlightHandler = publishFlightHandler;
const getNearbyFlightsHandler = (asAPilot, timezone) => {
    (0, flights_1.getNearbyFlights)(asAPilot, timezone).then(response => {
        store_1.store.dispatch((0, flight_1.setFlights)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.getNearbyFlightsHandler = getNearbyFlightsHandler;
const SearchFlightsHandler = (searchData, searchFlightRequests, navigate) => {
    const getEndDate = (startDate, endDate) => {
        if (endDate) {
            return (0, moment_1.default)(endDate).endOf("day").toISOString(true).slice(0, -6) + "Z";
        }
        else if (startDate) {
            return (0, moment_1.default)(startDate).endOf("day").toISOString(true).slice(0, -6) + "Z";
        }
        else
            return null;
    };
    const preparedSearchData = {
        departure: searchData.departureAirport ? searchData.departureAirport?.id : null,
        destination: searchData.destinationAirport ? searchData.destinationAirport?.id : null,
        passengers: searchData.passengers || null,
        start_date: searchData.startDate ? new Date(searchData.startDate).toISOString() : null,
        end_date: getEndDate(searchData.startDate, searchData.endDate),
    };
    (0, flights_1.getSearchedFlights)(preparedSearchData, searchFlightRequests).then(response => {
        store_1.store.dispatch((0, flight_1.setFlights)(response));
        navigate();
    }).catch(error => {
        console.log(error);
    });
};
exports.SearchFlightsHandler = SearchFlightsHandler;
const getMyFlightsHandler = (asAPilot) => {
    asAPilot ?
        (0, flights_1.getPilotFlights)().then(response => {
            store_1.store.dispatch((0, flight_1.setMyFlights)(response));
        }).catch(error => {
            store_1.store.dispatch((0, flight_1.setMyFlights)([]));
            console.log(error);
        }) :
        (0, flights_1.getPassengerFlights)().then(response => {
            store_1.store.dispatch((0, flight_1.setMyFlights)(response));
        }).catch(error => {
            store_1.store.dispatch((0, flight_1.setMyFlights)([]));
            console.log(error);
        });
};
exports.getMyFlightsHandler = getMyFlightsHandler;
const getMyOffersHandler = (asAPilot) => {
    asAPilot ?
        (0, flights_1.getPilotOffers)().then(response => {
            store_1.store.dispatch((0, flight_1.setMyOffers)(response.map((obj) => ({ ...obj, type: "FlightOffer" }))));
        }).catch(error => {
            store_1.store.dispatch((0, flight_1.setMyOffers)([]));
            console.log(error);
        })
        :
            store_1.store.dispatch((0, flight_1.setMyOffers)([]));
};
exports.getMyOffersHandler = getMyOffersHandler;
const getFlightDetailsHandler = (flightId) => {
    (0, flights_1.getFlightDetails)(flightId).then(response => {
        store_1.store.dispatch((0, flight_1.setFlightDetails)((0, utils_1.prepareFlightDetailsData)(response)));
    }).catch(error => {
        console.log(error);
    });
};
exports.getFlightDetailsHandler = getFlightDetailsHandler;
const getMyFlightDetailsHandler = (flightId) => {
    (0, flights_1.getMyFlightDetails)(flightId).then(response => {
        store_1.store.dispatch((0, flight_1.setFlightDetails)((0, utils_1.prepareFlightDetailsData)(response)));
        (0, exports.getFlightNotificationCountHandler)();
    }).catch(error => {
        console.log(error);
    });
};
exports.getMyFlightDetailsHandler = getMyFlightDetailsHandler;
const cancelFlightHandler = async (flightId, cancelMessage, navigate, asAPilot) => {
    try {
        if (asAPilot) {
            await (0, flights_1.cancelFlightAsPilot)(flightId, cancelMessage);
        }
        else {
            await (0, flights_1.cancelFlightAsPassenger)(flightId);
        }
        navigate();
    }
    catch (error) {
        console.log(error);
        throw error;
    }
};
exports.cancelFlightHandler = cancelFlightHandler;
const ratePassengersHandler = (flightId, userRatings) => {
    const filteredUserRatings = userRatings.filter(userRating => userRating.rating > 0);
    (0, flights_1.ratePassengers)(flightId, filteredUserRatings).then(status => {
        if (status === 200) {
            (0, exports.getFlightDetailsHandler)(flightId);
        }
    }).catch(error => {
        console.log(error);
    });
};
exports.ratePassengersHandler = ratePassengersHandler;
const ratePilotHandler = (flightId, userRating) => {
    (0, flights_1.ratePilot)(flightId, userRating).then(status => {
        if (status === 200) {
            (0, exports.getFlightDetailsHandler)(flightId);
        }
    }).catch(error => {
        console.log(error);
    });
};
exports.ratePilotHandler = ratePilotHandler;
const offerFlightHandler = (flightId, data, navigate) => {
    const requestData = {
        price: data.price,
        departure_from_id: data.departureAirport ? data.departureAirport.id : null,
        destination_to_id: data.destinationAirport ? data.destinationAirport.id : null,
        departure_datetime: data.date,
        aircraft_id: data.aircraft && (0, lodash_1.isNumber)(data.aircraft.id) ? data.aircraft.id : null,
        stopovers: data.stopovers,
        flight_time: data.duration
    };
    (0, flights_1.offerFlight)(flightId, requestData).then(response => {
        if (response.status === 200) {
            store_1.store.dispatch((0, flight_1.resetPublishFlightOfferAction)());
            navigate();
        }
    }).catch(error => {
        console.log(error);
    });
};
exports.offerFlightHandler = offerFlightHandler;
const getFlightOfferHandler = (offerId) => {
    (0, flights_1.getFlightOffer)(offerId).then(response => {
        store_1.store.dispatch((0, flight_1.setFlightOffer)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.getFlightOfferHandler = getFlightOfferHandler;
const declineFlightOfferHandler = async (offerId, flightId, setOffer) => {
    (0, flights_1.declineFlightOffer)(offerId).then(response => {
        (0, exports.getMyFlightDetailsHandler)(flightId);
        setOffer(response);
    }).catch(error => {
        console.log(error);
    });
};
exports.declineFlightOfferHandler = declineFlightOfferHandler;
const changeDedicatedStatusHandler = (flightId, dedicated) => {
    (0, flights_1.changeDedicatedStatus)(flightId, dedicated).then(response => {
        if (response.status === 200) {
            (0, exports.getMyFlightDetailsHandler)(flightId);
        }
    }).catch(error => {
        console.log(error);
    });
};
exports.changeDedicatedStatusHandler = changeDedicatedStatusHandler;
const startFlightPaymentHandler = (flightId, passengers) => {
    (0, flights_1.startFlightPayment)(flightId, passengers).then(response => {
        window.location.replace(response.data.url);
    }).catch(error => {
        console.log(error);
    });
};
exports.startFlightPaymentHandler = startFlightPaymentHandler;
const startFlightOfferPaymentHandler = (offerId, passengers) => {
    (0, flights_1.startFlightOfferPayment)(offerId, passengers).then(response => {
        window.location.replace(response.data.url);
    }).catch(error => {
        console.log(error);
    });
};
exports.startFlightOfferPaymentHandler = startFlightOfferPaymentHandler;
const getFlightTotalPriceHandler = (flightId, passengers, setPrices) => {
    (0, flights_1.getFlightTotalPrice)(flightId, passengers).then(response => {
        setPrices(response.data);
    }).catch(error => {
        console.log(error);
    });
};
exports.getFlightTotalPriceHandler = getFlightTotalPriceHandler;
const getFlightOfferTotalPriceHandler = (offerId, passengers, setPrices) => {
    (0, flights_1.getFlightOfferTotalPrice)(offerId, passengers).then(response => {
        setPrices(response.data);
    }).catch(error => {
        console.log(error);
    });
};
exports.getFlightOfferTotalPriceHandler = getFlightOfferTotalPriceHandler;
const getFlightNotificationCountHandler = () => {
    (0, flights_1.getFlightNotificationCount)().then(data => {
        store_1.store.dispatch((0, flight_1.setNotificationCountAction)(data));
    }).catch(error => {
        console.log(error);
    });
};
exports.getFlightNotificationCountHandler = getFlightNotificationCountHandler;
const refreshNotificationsHandler = (isAuthenticated) => {
    if (isAuthenticated) {
        setTimeout(() => {
            (0, messageHandlers_1.getAllChatsHandler)();
            (0, exports.getFlightNotificationCountHandler)();
        }, 10);
    }
};
exports.refreshNotificationsHandler = refreshNotificationsHandler;
const refreshNotificationsWithIntervalHandler = (isAuthenticated) => {
    if (isAuthenticated) {
        const intervalId = setInterval(() => {
            (0, messageHandlers_1.getAllChatsHandler)();
            (0, exports.getFlightNotificationCountHandler)();
        }, 30000);
        return () => clearInterval(intervalId);
    }
};
exports.refreshNotificationsWithIntervalHandler = refreshNotificationsWithIntervalHandler;
